import { memo, useCallback } from "react"

import { ColorPickerPopover, type ColorPickerPopoverProps } from "../../../components/Popovers/ColorPickerPopover"
import { useFallbackEditor, useTextStyleState } from "../../hooks"
import type { OptionalEditorProps } from "../typings"

interface TextColorDropdownMenuProps
	extends Omit<ColorPickerPopoverProps, "color" | "onColorChange" | "required">, OptionalEditorProps {}

export const TextColorPickerPopover = memo<TextColorDropdownMenuProps>((props) => {
	const { children, editor: editorFromProps, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const state = useTextStyleState(editor)

	const handleColorChange = useCallback(
		(color: string | undefined) => {
			editor.chain().focus().toggleTextStyle({ color }).run()
		},
		[editor],
	)

	return (
		<ColorPickerPopover required={false} color={state?.color} onColorChange={handleColorChange} {...rest}>
			{children}
		</ColorPickerPopover>
	)
})
TextColorPickerPopover.displayName = "TextColorDropdownMenu"
